import { useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "./ui/dialog";
import { Upload, CheckCircle2 } from "lucide-react";
import { fileUrl } from "../lib/api";

export const DeliverDialog = ({ jobId, onDone }) => {
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [note, setNote] = useState("");
  const [photo, setPhoto] = useState(null);

  const uploadPhoto = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setPhoto(data.path);
      toast.success("Photo uploaded");
    } catch { toast.error("Upload failed"); }
    e.target.value = "";
  };

  const submit = async () => {
    setSaving(true);
    try {
      await api.post(`/transport-jobs/${jobId}/deliver`, { note, photo });
      toast.success("Marked as delivered");
      setOpen(false);
      onDone && onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" className="rounded-none bg-primary hover:bg-primary/90" data-testid={`deliver-btn-${jobId}`}>
          <CheckCircle2 className="h-4 w-4 mr-1" /> Mark delivered
        </Button>
      </DialogTrigger>
      <DialogContent className="rounded-none">
        <DialogHeader><DialogTitle className="font-display">Proof of delivery</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="label-caps">Delivery note</Label>
            <Textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} className="rounded-none mt-1" placeholder="e.g. Delivered to reception, signed by J. Smith" data-testid="deliver-note" />
          </div>
          <div>
            <Label className="label-caps">Delivery photo (optional)</Label>
            <div className="flex items-center gap-3 mt-1">
              {photo && <img src={fileUrl(photo)} alt="proof" className="h-12 w-12 object-cover border border-border" />}
              <label className="cursor-pointer">
                <Button asChild size="sm" variant="outline" className="rounded-none pointer-events-none"><span><Upload className="h-4 w-4 mr-1" />{photo ? "Replace" : "Upload"}</span></Button>
                <input type="file" accept="image/*" className="hidden" onChange={uploadPhoto} data-testid="deliver-photo-input" />
              </label>
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button onClick={submit} disabled={saving} className="rounded-none bg-primary hover:bg-primary/90" data-testid="submit-deliver-btn">{saving ? "Submitting…" : "Confirm delivery"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
